// app/customs/mymodal/index.tsx
'use client';
import React from "react";
import * as Global from "@utils/global";
import ReactDOM from "react-dom";
import "./index.css";

type ModalProps = {
  children: React.ReactNode;
  onClose: () => void;
};

const MyModal: React.FC<ModalProps> = ({ children, onClose }) => {

  return ReactDOM.createPortal(
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()} // 中身クリックで閉じない
      >
        <button className="modal-close" onClick={onClose}>
            <i className="far fa-times-circle"></i>
        </button>
        {children}
      </div>
    </div>,
    document.body
  );

};

export default MyModal;
